import styled from 'styled-components';

import {
  HERO_FONT_DISPLAY,
  LandingHero,
} from 'constants/landing-hero';

const MOBILE = '@media (max-width: 768px)';

export const Wrap = styled.div<{ $align?: 'left' | 'center' }>`
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  max-width: 76rem;
  text-align: ${({ $align }) => $align ?? 'left'};
  align-items: ${({ $align }) => ($align === 'center' ? 'center' : 'flex-start')};
`;

export const Kicker = styled.div`
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
  color: ${LandingHero.creator.kicker};
`;

export const Title = styled.div<{ $onDark?: boolean }>`
  font-family: ${HERO_FONT_DISPLAY};
  font-weight: 800;
  font-size: 3.2rem;
  line-height: 1.08;
  letter-spacing: -0.12rem;
  color: ${LandingHero.textPrimary};

  ${MOBILE} {
    font-size: 2.4rem;
  }
`;

export const Subtitle = styled.div<{ $onDark?: boolean }>`
  font-size: 1.6rem;
  line-height: 1.6;
  color: ${LandingHero.textMuted};
`;
